/**
 * ブランドLP2フォームの初期化と制御
 * 都道府県・市区町村・教室の連動選択と履歴書き換え処理を実行
 */
$(function() {
	//ajaxで市区町村リスト取得
	$('.js-kousha-selector-pref').on('change', function() {
		let jukuId = $('#juku_id').val();
		if (jukuId == "") return;
		emptyKoushaSelector();
		emptyCitySelector();
		$("select[name='city_cd'] option").remove();
		$("select[name='city_cd']").append($('<option>').html("市区町村を選択").val(""));
		let prefCd = $(this).val();
		if (prefCd == "") return;

		// 遷移時に必要なデータをセット
		$("input[name='pref_cd']").val(prefCd);
		
		$.ajax({
			type: "POST",
			url: "/brand_lp2/get_city_list_by_juku_pref/" + jukuId + "/" + prefCd + "/"
		}).done(function(res) {
			for (var i in res.list) {
				// 市区町村を追加
				$(".js-kousha-selector-city").append($('<option value="' + i + '">').html(res.list[i]).val(i));
			}
		});
	});
	
	//ajaxで教室リスト取得
	$('.js-kousha-selector-city').on('change', function() {
		let jukuId = $('#juku_id').val();
		if (jukuId == "") return;
		emptyKoushaSelector();
		let cityCd = $(this).val();

		// 遷移時に必要なデータをセット
		$("input[name='city_cd']").val(cityCd);

		if (cityCd == "") return;
		
		$.ajax({
			type: "POST",
			url: "/brand_lp2/get_kousha_list_with_station_by_juku_pref_city/" + jukuId + "/" + cityCd + "/"
		}).done(function(res) {
			for (var i in res.list) {
				// 教室を追加(データ属性に教室名,PPC(塾ナビ用固定))
				var $opt = $('<option id="' + res.list[i].Kousha.kousha_id + '" data-kousha-name="' + res.list[i].Kousha.kousha_name + '">').html(res.list[i].Kousha.kousha_station_name).val(res.list[i].Kousha.kousha_id);
				if (res.list[i].Kousha.single_cv_flg !== undefined) {
					// 一社請求フラグを付与
					$opt.attr('data-single-cv-flg', res.list[i].Kousha.single_cv_flg);
				}
				$(".js-kousha-selector-kousha").append($opt);
			}
		});
	});
	
	//教室を選択
	$('.js-kousha-selector-kousha').on('change', function() {
		$('.js-inquiry-input').hide();
		var jukuId = $('#juku_id').val();
		var prefCd = $('.js-kousha-selector-pref').val();
		var cityCd = $('.js-kousha-selector-city').val();
		var koushaId = $(this).val();
		var singleCvFlg = $(this).find('option:selected').attr('data-single-cv-flg');
		$('input[name=kousha_id\\[\\]]').val(koushaId);
		$('.js-chk-kousha').val(koushaId);
		$('.js-chk-kousha').prop('checked', koushaId != "");
		// // バリデーションが実行されるように、発火
		$('.js-chk-kousha').trigger('change');
		$('#inquiryConfirmForm').attr('action', '/brandlp2/inquiry/thanks');
		// 一社請求不可の場合は本体の確認画面へ遷移
		if (singleCvFlg == 0) {
			$('#inquiryConfirmForm').attr('action', '/inquiry/confirm');
		}
	});
	
	// // 資料請求をするボタンをクリック
	$('.js-rewrite-history').on('click', function() {
		// 選択した都道府県、市区町村、教室名を取得する
		var prefCd = $('.js-kousha-selector-pref').val();
		var cityCd = $('.js-kousha-selector-city').val();
		var koushaId = $('.js-kousha-selector-kousha').val();
		// いずれかが未選択の場合は何もしない
		if (prefCd == "" || cityCd == "" || koushaId == "") {
			return;
		}
		// pathに都道府県、市区町村、教室名のパラメータを付与する（既にパラメータが入っていても選択した値で設定しなおす）
		history.replaceState('', '', location.pathname + '?pref_cd=' + prefCd + '&city_cd=' + cityCd + '&search_kousha_id=' + koushaId + '#before-form');
	});

	/**
	 * 市区町村選択プルダウンを初期化する
	 * 選択肢をクリアして初期状態に戻す
	 */
	function emptyCitySelector() {
		$("select[name='city_cd'] option").remove();
		$("select[name='city_cd']").append($('<option>').html("市区町村を選択").val(""));
		$("input[name='city_cd']").val("");
	}

	/**
	 * 教室選択プルダウンを初期化する
	 * 選択肢をクリアして初期状態に戻す
	 */
	function emptyKoushaSelector() {
		$("select[name='search_kousha_id'] option").remove();
		$("select[name='search_kousha_id']").append($('<option>').html("教室を選択").val(""));
	}
});